// extracted by mini-css-extract-plugin
export default {"itemImg":"starCards_itemImg__zAeKI","itemBottom":"starCards_itemBottom__6WkTL","itemTitle":"starCards_itemTitle__YRjOO"};